export const getAriaLabel = (ariaLabel, children) => {
  if (ariaLabel) return ariaLabel;
  if (typeof children === 'string') return children;
  return undefined;
};

export const hasLoadingState = (loading) => {
  return loading === true;
};

export const resolveIconClass = (icon) => {
  if (!icon) return '';
  return icon.includes(' ') ? icon : `fas fa-${icon}`;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Button/utils/buttonHelpers.js